import React from 'react';
import CheckboxInput from '../../../../../../Shared/Ui/CustomInputs/CheckboxInput/CheckboxInput';
import { TemplateEntity } from '@entities/Template/Types';
import styles from './TemplatesCheckboxList.module.css';
import { CustomProjectStep1ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep1ElementsIdsEnum';

interface Props {
    template?: TemplateEntity;
}

const TemplatesCheckboxList: React.FC<Props> = ({ template }) => (
    <section
        className={styles.section}
        id={
            CustomProjectStep1ElementsIdsEnum.TEMPLATE_MEASUREMENTS_STEP1_FILLING_SECTION
        }
    >
        <h3 className={styles.templateTitle}>Template: {template?.title}</h3>
        <div className={styles.fillingSection}>
            {template?.fragments.map((fragment, idx) => {
                const isChecked = fragment.questions.every(
                    question => question.value
                );
                return (
                    <div className={styles.fillingCheckboxBlock} key={idx}>
                        <div className={styles.fillingText}>
                            {idx + 1}. {fragment.title}
                        </div>
                        <CheckboxInput
                            id={`chk-${idx}`}
                            checked={isChecked}
                            readOnly
                        />
                    </div>
                );
            })}
        </div>
    </section>
);

export default TemplatesCheckboxList;
